import * as React from "react"

import clsxm from "@/lib/clsxm"

import { Header } from "@/components/common/Layout/Header"

class LayoutComponent extends React.PureComponent<{
  children: React.ReactNode
  className?: string
  header?: boolean
}> {
  public render = (): React.ReactElement => {
    return (
      <div
        className={clsxm(
          `flex min-h-screen flex-1 flex-col`,
          [this.props.header !== false ? `pt-[123px] md:pt-20` : null],
          this.props.className
        )}
      >
        {this.props.header !== false ? <Header /> : null}

        {this.props.children}
      </div>
    )
  }
}

export { LayoutComponent as Layout }
